import { useTranslation } from 'react-i18next';
import logo1 from '../../../../blocks/Homepage/testimonials-logos/remax-logo.png';
import logo2 from '../../../../blocks/Homepage/testimonials-logos/quaidao-logo.png';
import logo3 from '../../../../blocks/Homepage/testimonials-logos/marrisson-logo.png';
import logo4 from '../../../../blocks/Homepage/testimonials-logos/apollorion-global-logo.png';
import logo5 from '../../../../blocks/Homepage/testimonials-logos/oneplan-logo.png';
import logo6 from '../../../../blocks/Homepage/testimonials-logos/nebulai-logo.png';

const Testimonials = () => {
  const { t } = useTranslation();

  return (
    <div className="py-16 px-16 sm:px-0 sm:py-24 w-full mx-auto max-w-screen-xl">
      {/* Full-width heading, centered */}
      <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-center mb-12">
      {t('pageSolutions.EarlyStageFounders.t21')}
      </h2>

      {/* Logo container — width constrained */}
      <section className="w-[75%] mx-auto text-center">
        <div className="grid grid-cols-2 gap-6 md:grid-cols-6 md:gap-8">
          {[logo1, logo2, logo3, logo4, logo5, logo6].map((logo, index) => (
            <img
              key={index}
              src={logo}
              alt={`Logo ${index + 1}`}
              className="w-full h-auto transform transition-all duration-300 ease-in-out hover:scale-110"
            />
          ))}
        </div>
      </section>
    </div>
  );
};

export default Testimonials;
